/**
 * Calcula o ponto central de uma bounding box (caixa delimitadora).
 * Recebe as coordenadas dos limites (top, left, bottom, right) e
 * retorna um objeto com a latitude e longitude do centro.
 */

export const getCenter = (bbox: { top: number; left: number; bottom: number; right: number }) => {
    return {
        lat: (bbox.top + bbox.bottom) / 2,
        lng: (bbox.left + bbox.right) / 2,
    };
}